import { combineReducers } from 'redux';
import projects from './projects';
import login from './login';
import common from './common';
import analysis from './analysis';
import insights from './insights';
import question from './question';
import systemSettings from './systemSettings';
import powerBIRefreshReducer from './powerBIRefresh';

const reducers = combineReducers({
  projects,
  login,
  common,
  analysis,
  insights,
  question,
  systemSettings,
  powerBIRefreshReducer,
});

export default reducers;
